import React, { useCallback, useEffect, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Col, Row, Spinner } from "react-bootstrap";
import CabinCard from "../../components/CabinCard";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearInputErrors,
  selectInputErrors,
} from "../../features/errors/errorsSlice";
import InputErrorsDisplay from "../../features/errors/InputErrorsDisplay";
import {
  AccommodationListItem,
  AccommodationQueryFilters,
  getAccommodationsAsync,
  selectAccommodationItems,
  selectAccommodationsLoadingStatus,
} from "../AccommodationsPage/accommodationsSlice";
import { useAuthUser } from "../../features/auth/authHooks";
import {
  InitialAllAccommodationsPaginationParameters,
  InitialPaginationParameters,
} from "../../types/pagination.types";
import { LOADING_STATUS } from "../../common/constants";

const PricingPageType: Page = {
  ActiveTab: "pricing",
  DisplayName: "Hinnoittelu",

  LinkUrl: "/pricing",
  Path: "/pricing",
  RouteName: "pricing",
};

const PricingPage = () => {
  const inputErrors = useAppSelector(selectInputErrors);
  const accommodations = useAppSelector(selectAccommodationItems);
  const [submitted, setSubmitted] = useState(false);
  const accommodationsLoadingStatus = useAppSelector(
    selectAccommodationsLoadingStatus,
  );
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const [filtering, setFiltering] = useState<AccommodationQueryFilters>({
    PageNumber: InitialAllAccommodationsPaginationParameters.PageNumber,
    PageSize: InitialAllAccommodationsPaginationParameters.PageSize,
    filterCriteria: {
      showDeleted: false,
      searchString: undefined,
      accommodationNumber: undefined,
      novelty: undefined,
      showInWebShop: undefined,
      showInOwnerPage: undefined,
      accommodationGroupId: undefined,
      accountId: ownerAccountId,
    },
  });
  const initFetch = useCallback(() => {
    dispatch(getAccommodationsAsync(filtering));
  }, [dispatch, ownerAccountId]);
  useEffect(() => {
    initFetch();
  }, [initFetch, ownerAccountId]);
  const renderAccommodations = (accommodations: AccommodationListItem[]) => {
    return accommodations
      .slice() // optional: clone array if you don't want to mutate original
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((accommodation) => renderAccommodation(accommodation));
  };
  const renderAccommodation = (accommodation) => {
    let location = "";
    if (accommodation.municipality && accommodation.municipality.length > 0) {
      location = accommodation.municipality;
    }
    if (accommodation.region && accommodation.region.length > 0) {
      location += ", " + accommodation.region;
    }
    if (accommodation.skiResort && accommodation.skiResort.length > 0) {
      location += ", " + accommodation.skiResort;
    }
    let description =
      accommodation.beds + " + " + accommodation.extraBeds + " henkilöä";
    let badgeText = "";
    let badgeBg = "";
    if (accommodation.novelty == 1) {
      badgeText = "Uutuus";
      badgeBg = "success";
    }
    if (accommodation.showInWebShop == 2) {
      badgeText = "Offline";
      badgeBg = "danger";
    }
    return (
      <Col key={accommodation.id}>
        <CabinCard
          Url={
            "/pricing/modify/" +
            accommodation.id +
            "?accommodation=" +
            accommodation.accommodationNumber +
            " - " +
            accommodation.name
          }
          ImgSrc={accommodation.imageUrl}
          Title={accommodation.accommodationNumber + ", " + accommodation.name}
          Location={location}
          Desc={description}
          BadgeBg={badgeBg}
          BadgeText={badgeText}
        />
      </Col>
    );
  };
  return (
    <div className={PricingPageType.RouteName}>
      <Layout CurrentPage={PricingPageType}>
        <PageHeader
          Title={PricingPageType.DisplayName}
          SubTitle={PricingPageType.DisplayParentName}
          Back={false}
          Icon="currency-euro"
        />
        <Row xs={1} sm={2} md={3} xl={4} className="g-24">
          {accommodationsLoadingStatus != LOADING_STATUS.IDLE && (
            <>
              <div className="d-flex gap-16 align-items-center">
                <Spinner animation="border" />
                <span>Ladataan kohteita...</span>
              </div>
            </>
          )}
          <>
            {accommodationsLoadingStatus == LOADING_STATUS.IDLE &&
              renderAccommodations(accommodations)}
          </>
        </Row>
      </Layout>
    </div>
  );
};

export default PricingPage;
